import { useEffect } from "react";
export var useExpressionQuestionValues = function (_a) {
    var expressionValues = _a.expressionValues, formValues = _a.formValues, setValue = _a.setValue;
    useEffect(function () {
        Object.entries(expressionValues).forEach(function (_a) {
            var valueKey = _a[0], value = _a[1];
            if (Object.is(formValues[valueKey], value)) {
                return;
            }
            setValue(valueKey, value, {
                shouldValidate: false,
                shouldDirty: false,
            });
        });
    }, [expressionValues, formValues, setValue]);
};
